module.exports = __webpack_public_path__ + "static/assets/cb7e62743f5b8d274083930dc47b9abc.png";